import { localTime } from 'js/helper.js';

document.addEventListener('DOMContentLoaded', event => {
  const device = window.Modernizr.Detectizr.device;
  const type = device.type !== 'mobile' ? 'desktop' : device.type;
  const env = 'browse';

  if (window.location.href.indexOf(env) < 0) {
    /* tracking leave page */
    window.addEventListener('beforeunload', function(e) {
      window.tracking.GAEvent('send', {
        hitType: 'event',
        eventCategory: `Customer Flow - Browse Design (${type})`,
        eventAction: 'Leave Page',
        dimension10: localTime()
      });
    });
    /* END: tracking leave page */
  }

  window.tracking.GAEvent('send', {
    hitType: 'event',
    eventCategory: `Customer Flow - Browse Design (${type})`,
    eventAction: 'Enter Page',
    dimension10: localTime()
  });
});
